import React from 'react';
import MailToWrapper from 'flow/components/custom-components/MailToWrapper';
import useAppContext from 'flow/hooks/useAppContext';
import { isEmbeddedTypeCti } from 'flow/utils/app-utils';
import MenuItem from '../ui-components/MenuItem';

interface Props {
    emailField?: string;
    handleClose?: () => void;
}

const EmailFieldMenuItem = ({ emailField, handleClose }: Props) => {
    const { i18next, embedded } = useAppContext();
    const isCtiEmbedded = isEmbeddedTypeCti(embedded);

    if (!emailField || isCtiEmbedded) {
        return null;
    }

    return (
        <MailToWrapper recipient={emailField} onClickSideEffect={handleClose}>
            <MenuItem>{`${i18next.t('Tooltip.Title.SendEmail')}...`}</MenuItem>
        </MailToWrapper>
    );
};

export default EmailFieldMenuItem;
